import React from "react";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "src/@/components/ui/dialog";
import { Button } from "src/@/components/ui/button";
import Iconify from "../Iconify";

const parseVCard = (vcard) => {
    const lines = vcard.split("\n");
    let contact = { name: "", phone: "", org: "" };

    lines.forEach((line) => {
        if (line.startsWith("FN:")) {
            contact.name = line.replace("FN:", "").trim();
        } else if (line.startsWith("TEL")) {
            const phoneMatch = line.match(/waid=[^:]+:([^]+)/);
            if (phoneMatch) {
                contact.phone = phoneMatch[1].trim();
            }
        } else if (line.startsWith("X-WA-BIZ-NAME")) {
            contact.org = line.replace("X-WA-BIZ-NAME:", "").trim();
        }
    });

    return contact;
};

const ModalMultiContact = ({ message }) => {
    const vcardData = message.vcardList || [];
    const contacts = vcardData.map((item) => parseVCard(item.vcard));

    return (
        <Dialog>
            <DialogTrigger asChild>
                <div className="">
                    <Button variant="secondary" className="w-full">
                        <Iconify icon="mingcute:contacts-4-fill" className="mr-2" />
                        {contacts.length} contatos encaminhados
                    </Button>
                </div>

            </DialogTrigger>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>{contacts.length} contatos encaminhados</DialogTitle>
                </DialogHeader>
                <div className="space-y-4">
                    {contacts.map((contact, index) => (
                        <div
                            key={index}
                            className="flex items-center justify-between border-b pb-2"
                        >
                            <div>
                                <p className="text-sm font-medium">{contact.name}</p>
                                <p className="text-xs text-muted-foreground">{contact.phone}</p>
                                {contact.org && (
                                    <p className="text-xs text-muted-foreground">{contact.org}</p>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default ModalMultiContact;
